var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import theme from '../theme';
export var Input = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  border: ", ";\n  border-radius: 4px;\n  padding: 5px;\n  cursor: regular;\n  min-height: 36px;\n  font-size: 14px;\n  padding-left: 8px;\n"], ["\n  background: ", ";\n  color: ", ";\n  border: ", ";\n  border-radius: 4px;\n  padding: 5px;\n  cursor: regular;\n  min-height: 36px;\n  font-size: 14px;\n  padding-left: 8px;\n"])), function (_a) {
    var mode = _a.mode;
    return theme[mode].background;
}, function (_a) {
    var mode = _a.mode;
    return theme[mode].fontColor;
}, function (_a) {
    var mode = _a.mode;
    return (mode === 'dark' ? 'none' : "1px solid " + theme[mode].borderColor);
});
var templateObject_1;
